"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var pomodoroContext_1 = __importStar(require("./pomodoroContext"));
var defaultStartedAt = new Date().getTime();
var SET_MODE = 'set-mode';
var PAUSE_TIMER = 'pause-timer';
var START_TIMER = 'start-timer';
var SET_CYCLE = 'set-cycle';
var CLEAR = 'clear';
var SET_FOCUS_TIME = 'set-focus-time';
var SET_BREAK_TIME = 'set-break-time';
var SET_CYCLES = 'set-cycles';
var SET_SOUND_ENABLED = 'set-sound-enabled';
var SET_STUDY_MODE_ENABLED = 'set-study-mode-enabled';
var SET_REMAINING_TIME = 'set-remaining-time';
var SET_START_REMAINING_TIME = 'set-start-remaining-time';
var SET_STARTED_AT = 'set-started-at';
var SET_TIMER = 'set-timer';
var START_CYCLE = 'start-cycle';
var ENABLE_PRESET = 'enable-preset';
var OPEN_POPOVER = 'open-popover';
var CLOSE_POPOVER = 'close-popover';
function reducer(state, action) {
    switch (action.type) {
        case SET_MODE:
            return __assign(__assign({}, state), { mode: action.mode });
        case SET_CYCLE:
            return __assign(__assign({}, state), { cycle: action.cycle });
        case OPEN_POPOVER:
            return __assign(__assign({}, state), { popoverOpen: true, message: action.message ? action.message : 'none' });
        case CLOSE_POPOVER:
            return __assign(__assign({}, state), { popoverOpen: false });
        case PAUSE_TIMER:
            return __assign(__assign({}, state), { paused: true });
        case START_TIMER:
            return __assign(__assign({}, state), { paused: false });
        case CLEAR:
            return __assign(__assign({}, state), { paused: true, remainingTime: state.focusTime, mode: 'inactive', message: 'none', cycle: 1 });
        case SET_FOCUS_TIME:
            return __assign(__assign({}, state), { focusTime: action.time, usingPreset: false });
        case SET_BREAK_TIME:
            return __assign(__assign({}, state), { breakTime: action.time, usingPreset: false });
        case SET_CYCLES:
            return __assign(__assign({}, state), { cycles: action.cycles, usingPreset: false });
        case SET_REMAINING_TIME:
            return __assign(__assign({}, state), { remainingTime: action.time });
        case SET_START_REMAINING_TIME:
            return __assign(__assign({}, state), { startRemainingTime: action.time, remainingTime: action.time });
        case SET_STARTED_AT:
            return __assign(__assign({}, state), { startedAt: action.date });
        case SET_SOUND_ENABLED:
            return __assign(__assign({}, state), { soundEnabled: action.enabled });
        case ENABLE_PRESET:
            return __assign(__assign({}, state), { usingPreset: true, focusTime: action.focusTime, breakTime: action.breakTime, cycles: action.cycles });
        case SET_TIMER:
            return __assign(__assign({}, state), { startedAt: new Date().getTime(), remainingTime: action.time, startRemainingTime: action.time, mode: action.mode || state.mode });
        case START_CYCLE:
            return __assign(__assign({}, state), { startedAt: new Date().getTime(), remainingTime: state.focusTime, startRemainingTime: state.focusTime, mode: 'focus', cycle: action.cycle });
        case SET_STUDY_MODE_ENABLED:
            return __assign(__assign({}, state), { studyMode: action.enabled });
        default:
            throw new Error();
    }
}
var PomodoroProvider = function (_a) {
    var _b = _a.focusTime, focusTimeProp = _b === void 0 ? pomodoroContext_1.presets.standard.focusTime : _b, _c = _a.breakTime, breakTimeProp = _c === void 0 ? pomodoroContext_1.presets.standard.breakTime : _c, _d = _a.cycles, cyclesProp = _d === void 0 ? pomodoroContext_1.presets.standard.cycles : _d, _e = _a.cycle, cycleProp = _e === void 0 ? 1 : _e, children = _a.children, _f = _a.mode, modeProp = _f === void 0 ? 'inactive' : _f, notificationAudioUrl = _a.notificationAudioUrl, focusAlertAudioUrl = _a.focusAlertAudioUrl, onClear = _a.onClear, onEnablePreset = _a.onEnablePreset, onPause = _a.onPause, onPlay = _a.onPlay, onReset = _a.onReset, onSetCycles = _a.onSetCycles, onSetBreakTime = _a.onSetBreakTime, onSetFocusTime = _a.onSetFocusTime, onSetStudyModeEnabled = _a.onSetStudyModeEnabled, onChangeMode = _a.onChangeMode, _g = _a.paused, pausedProp = _g === void 0 ? true : _g, startRemainingTimeProp = _a.remainingTime, _h = _a.startedAt, startedAtProp = _h === void 0 ? defaultStartedAt : _h, soundEnabledProp = _a.soundEnabled, studyModeProp = _a.studyMode;
    var tickRef = react_1.useRef();
    var _j = __read(react_1.useState(new Audio(notificationAudioUrl)), 1), notificationAudio = _j[0];
    var _k = __read(react_1.useState(new Audio(focusAlertAudioUrl)), 1), focusAlertAudio = _k[0];
    var _l = __read(react_1.useState(false), 2), audioUnlocked = _l[0], setAudioUnlocked = _l[1];
    var _m = __read(react_1.useReducer(reducer, {
        cycles: cyclesProp,
        paused: pausedProp,
        focusTime: focusTimeProp,
        breakTime: breakTimeProp,
        cycle: cycleProp,
        remainingTime: startRemainingTimeProp || focusTimeProp,
        startRemainingTime: startRemainingTimeProp || focusTimeProp,
        startedAt: startedAtProp,
        mode: modeProp,
        message: 'none',
        popoverOpen: false,
        soundEnabled: soundEnabledProp || true,
        usingPreset: false,
        studyMode: studyModeProp || false,
    }), 2), state = _m[0], dispatch = _m[1];
    var cycles = state.cycles, paused = state.paused, focusTime = state.focusTime, breakTime = state.breakTime, cycle = state.cycle, message = state.message, mode = state.mode, startedAt = state.startedAt, remainingTime = state.remainingTime, startRemainingTime = state.startRemainingTime, popoverOpen = state.popoverOpen, soundEnabled = state.soundEnabled, usingPreset = state.usingPreset, studyMode = state.studyMode;
    // Percentage of the current countdown
    var progress = (remainingTime / (mode !== 'break' ? focusTime : breakTime)) * 100;
    react_1.useEffect(function () {
        // Safari requires first audio play to be
        // triggered by a user action.
        function unlockAudio() {
            notificationAudio.play();
            notificationAudio.pause();
            notificationAudio.currentTime = 0;
            document.body.removeEventListener('click', unlockAudio);
            document.body.removeEventListener('touchstart', unlockAudio);
            setAudioUnlocked(true);
        }
        document.body.addEventListener('click', unlockAudio);
        document.body.addEventListener('touchstart', unlockAudio);
    }, [notificationAudio]);
    react_1.useEffect(function () {
        if (pausedProp !== paused) {
            if (pausedProp) {
                dispatch({ type: PAUSE_TIMER });
            }
            else {
                dispatch({ type: START_TIMER });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pausedProp]);
    react_1.useEffect(function () {
        if (studyModeProp !== studyMode) {
            dispatch({
                type: SET_STUDY_MODE_ENABLED,
                enabled: studyModeProp || false,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studyModeProp]);
    react_1.useEffect(function () {
        if (typeof startRemainingTimeProp === 'number' &&
            startRemainingTimeProp !== startRemainingTime) {
            dispatch({
                type: SET_START_REMAINING_TIME,
                time: startRemainingTimeProp,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startRemainingTimeProp]);
    react_1.useEffect(function () {
        if (modeProp !== mode) {
            if (modeProp === 'inactive') {
                dispatch({ type: CLEAR });
            }
            else {
                dispatch({ type: SET_MODE, mode: modeProp });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modeProp]);
    react_1.useEffect(function () {
        if (cycleProp !== cycle) {
            dispatch({ type: SET_CYCLE, cycle: cycleProp });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cycleProp]);
    react_1.useEffect(function () {
        if (startedAtProp !== startedAt) {
            dispatch({ type: SET_STARTED_AT, date: startedAtProp });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startedAtProp]);
    var debouncedFocusTime = core_1.useDebounce(focusTime, 1000);
    react_1.useEffect(function () {
        if (onSetFocusTime &&
            debouncedFocusTime !== focusTimeProp &&
            !usingPreset) {
            onSetFocusTime(debouncedFocusTime);
        }
    }, [debouncedFocusTime, focusTimeProp, onSetFocusTime, usingPreset]);
    var debouncedBreakTime = core_1.useDebounce(breakTime, 1000);
    react_1.useEffect(function () {
        if (onSetBreakTime &&
            debouncedBreakTime !== breakTimeProp &&
            !usingPreset) {
            onSetBreakTime(debouncedBreakTime);
        }
    }, [breakTimeProp, debouncedBreakTime, onSetBreakTime, usingPreset]);
    var debouncedCycles = core_1.useDebounce(cycles, 1000);
    react_1.useEffect(function () {
        if (onSetCycles && debouncedCycles !== cyclesProp && !usingPreset) {
            onSetCycles(debouncedCycles);
        }
    }, [cyclesProp, debouncedCycles, onSetCycles, usingPreset]);
    var playNotificationSound = react_1.useCallback(function () {
        try {
            if (audioUnlocked) {
                notificationAudio.play();
            }
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err.message);
        }
    }, [audioUnlocked, notificationAudio]);
    var playFocusAlertSound = react_1.useCallback(function () {
        try {
            if (audioUnlocked) {
                focusAlertAudio.play();
            }
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err.message);
        }
    }, [audioUnlocked, focusAlertAudio]);
    var tick = react_1.useCallback(function () {
        if (!paused && remainingTime > 0) {
            var now = new Date().getTime();
            var newRemainingTime = startRemainingTime - Math.floor((now - startedAt) / 1000);
            if (newRemainingTime !== remainingTime) {
                dispatch({ type: SET_REMAINING_TIME, time: newRemainingTime });
            }
        }
        else if (remainingTime === 0 && !(cycle === cycles && mode === 'break')) {
            if (mode === 'focus') {
                playNotificationSound();
                dispatch({
                    type: SET_TIMER,
                    time: breakTime,
                    mode: 'break',
                });
                dispatch({
                    type: OPEN_POPOVER,
                    message: 'break',
                });
                if (onChangeMode) {
                    onChangeMode('break', breakTime, cycle);
                }
            }
            else {
                playNotificationSound();
                dispatch({
                    type: START_CYCLE,
                    cycle: cycle + 1,
                });
                dispatch({
                    type: OPEN_POPOVER,
                    message: 'focus',
                });
                if (onChangeMode) {
                    onChangeMode('focus', focusTime, cycle + 1);
                }
            }
        }
        else if (!paused && remainingTime === 0) {
            playNotificationSound();
            dispatch({ type: PAUSE_TIMER });
            if (onPause) {
                onPause(0);
            }
            dispatch({ type: OPEN_POPOVER, message: 'complete' });
        }
        else if (!paused) {
            dispatch({ type: PAUSE_TIMER });
            if (onPause) {
                onPause(remainingTime);
            }
        }
        if (remainingTime < 0) {
            dispatch({
                type: SET_START_REMAINING_TIME,
                time: new Date().getTime(),
            });
            dispatch({
                type: SET_REMAINING_TIME,
                time: mode === 'break' ? breakTime : focusTime,
            });
        }
    }, [
        breakTime,
        cycle,
        cycles,
        focusTime,
        mode,
        onChangeMode,
        onPause,
        paused,
        playNotificationSound,
        remainingTime,
        startRemainingTime,
        startedAt,
    ]);
    tickRef.current = tick;
    var _o = __read(react_1.useState(null), 2), counterInterval = _o[0], setTimerInterval = _o[1];
    react_1.useEffect(function () {
        var id;
        if (paused === false && !counterInterval) {
            id = window.setInterval(function () { return tickRef.current && tickRef.current(); }, 200);
            setTimerInterval(id);
        }
        else if (paused !== false && counterInterval) {
            clearInterval(counterInterval);
            setTimerInterval(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counterInterval, paused]);
    var play = react_1.useCallback(function () {
        var newMode = mode === 'inactive' ? 'focus' : mode;
        dispatch({
            type: SET_TIMER,
            time: remainingTime,
            mode: newMode,
        });
        dispatch({ type: START_TIMER });
        if (onPlay) {
            onPlay(newMode, remainingTime);
        }
    }, [mode, onPlay, remainingTime]);
    var pause = react_1.useCallback(function () {
        dispatch({ type: PAUSE_TIMER });
        if (onPause) {
            onPause(remainingTime);
        }
    }, [onPause, remainingTime]);
    var clear = react_1.useCallback(function () {
        dispatch({ type: CLEAR });
        if (onClear) {
            onClear(focusTime);
        }
    }, [focusTime, onClear]);
    var reset = react_1.useCallback(function () {
        var newRemainingTime = mode !== 'break' ? focusTime : breakTime;
        if (remainingTime === newRemainingTime) {
            if (mode === 'break') {
                dispatch({
                    type: SET_TIMER,
                    time: focusTime,
                    mode: 'focus',
                });
                if (onChangeMode) {
                    onChangeMode('focus', focusTime, cycle);
                }
            }
            else if (mode === 'focus' && cycle > 1) {
                dispatch({
                    type: START_CYCLE,
                    cycle: cycle - 1,
                });
                if (onChangeMode) {
                    onChangeMode('focus', focusTime, cycle - 1);
                }
            }
        }
        else {
            dispatch({
                type: SET_TIMER,
                time: newRemainingTime,
            });
            if (onReset) {
                onReset(newRemainingTime);
            }
        }
    }, [breakTime, cycle, focusTime, mode, onChangeMode, onReset, remainingTime]);
    var setFocusTime = react_1.useCallback(function (time) {
        dispatch({
            type: SET_FOCUS_TIME,
            time: time,
        });
    }, []);
    var setBreakTime = react_1.useCallback(function (time) {
        dispatch({
            type: SET_BREAK_TIME,
            time: time,
        });
    }, []);
    var setCycles = react_1.useCallback(function (count) {
        dispatch({
            type: SET_CYCLES,
            cycles: count,
        });
    }, []);
    var setStudyModeEnabled = react_1.useCallback(function (enabled) {
        dispatch({
            type: SET_STUDY_MODE_ENABLED,
            enabled: enabled,
        });
        if (onSetStudyModeEnabled) {
            onSetStudyModeEnabled(enabled);
        }
    }, [onSetStudyModeEnabled]);
    var enablePreset = react_1.useCallback(function (set) {
        dispatch(__assign({ type: ENABLE_PRESET }, set));
        if (onEnablePreset) {
            onEnablePreset(set);
        }
    }, [onEnablePreset]);
    var openPopover = react_1.useCallback(function () {
        dispatch({ type: OPEN_POPOVER });
    }, []);
    var closePopover = react_1.useCallback(function () {
        dispatch({ type: CLOSE_POPOVER });
    }, []);
    return (react_1.default.createElement(pomodoroContext_1.default.Provider, { value: __assign(__assign({}, pomodoroContext_1.defaultValue), { breakTime: breakTime,
            clear: clear,
            closePopover: closePopover,
            cycle: cycle,
            cycles: cycles,
            enablePreset: enablePreset,
            focusTime: focusTime,
            message: message,
            mode: mode,
            openPopover: openPopover,
            pause: pause,
            paused: paused,
            play: play,
            playFocusAlertSound: playFocusAlertSound,
            studyMode: studyMode,
            popoverOpen: popoverOpen,
            presets: pomodoroContext_1.presets,
            progress: progress,
            remainingTime: remainingTime,
            reset: reset,
            setBreakTime: setBreakTime,
            setCycles: setCycles,
            setFocusTime: setFocusTime,
            soundEnabled: soundEnabled,
            setStudyModeEnabled: setStudyModeEnabled }) }, children));
};
exports.default = PomodoroProvider;
//# sourceMappingURL=PomodoroProvider.js.map